import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
    fetchWhatsappTemplateAll,
    createTemplateWhatsapp,
    updateTemplateWhatsapp

} from "@/services/whatsappTemplate";

@Module({
  namespaced: true
})
export default class whatsappTemplate extends VuexModule {

  // state
    fetchWhatsappTemplateList = [];

  // Action

  @Action
  public async fetchWhatsappTemplateAction(payload) {
    try {
      const data = await fetchWhatsappTemplateAll(payload);
      this.context.commit("setWhatsappTemplateList", data.data);
      return data.data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async createWhatsappTemplate(payload) {
    try {
      const data = await createTemplateWhatsapp(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async updateWhatsappTemplate(payload) {
    try {
      const data = await updateTemplateWhatsapp(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  //Mutations

  @Mutation
  public setWhatsappTemplateList(data: any) {
    this.fetchWhatsappTemplateList = data;
  }

  //Getters
  get GetFetchWhatsappTemplateList() {
    return this.fetchWhatsappTemplateList;
  }

}
